module.exports = __webpack_public_path__ + "media/images/circle_person-2f597fed36af4fb6e8b678659cd5d338.svg";